// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"28c36cee","703":"85b0e0c7","787":"7694d617"}[chunkId] + ".chunk.js";
};